import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  clickOnMobileMenu: null,
  clickCollapseMenu: ['status'],

  getBranchesRequest: null,
  getBranchesSuccess: ['response'],
  getBranchesFailure: null,

  getRolesRequest: null,
  getRolesSuccess: ['response'],
  getRolesFailure: null,

  getAlertsRequest: null,
  getAlertsSuccess: ['response'],
  getAlertsFailure: null,

  toggleAlertRequest: ['payload'],
  toggleAlertSuccess: ['response'],
  toggleAlertFailure: ['payload'],

  getServerTimeRequest: null,
  getServerTimeSuccess: ['response'],
  getServerTimeFailure: null,

  setServerTimeRequest: ['payload'],
  setServerTimeSuccess: ['response'],
  setServerTimeFailure: null,

  // Clear all caches
  clearAppRequest: null,
});

export const AppTypes = Types;
export default Creators;
